import SectionHeader from "../components/SectionHeader";
import SEO from "../components/SEO";
import { TARGET_PARTNERS } from "../lib/content";
import { Link } from "react-router-dom";

export default function PartnersPage() {
  return (
    <main data-testid="page-partners">
      <SEO
        path="/partners"
        image="/brand/og-partners.jpg"
        title="Partners"
        description="Target partner profile: defense primes, eVTOL OEMs, marine propulsion OEMs, energy storage system integrators, and robotics platform builders looking to integrate next-generation speed reducer technology."
      />
      <section className="relative pt-24 pb-16 md:pt-32 md:pb-20 border-b border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <SectionHeader
              kicker="/ partners · investors"
              title={<>Built to be<br />integrated.</>}
              lead="Our roadmap is designed around a small number of deep partnerships —
not a crowded customer list. Below are the kinds of organizations we are
actively briefing, and the shape of the partnership we propose."
            />
          </div>
          <div className="md:col-span-4">
            <Link
              to="/contact"
              data-testid="partners-cta"
              className="inline-flex items-center gap-3 bg-[#FF3B30] hover:bg-[#FF5C53] text-white font-mono-tech uppercase tracking-widest text-xs px-6 py-4"
            >
              Open a partnership conversation
            </Link>
          </div>
        </div>
      </section>

      <section className="relative py-24 md:py-28" data-testid="partners-grid">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/50">
            / target development partners
          </div>
          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-[1px] bg-white/10 border border-white/10">
            {TARGET_PARTNERS.map((p) => (
              <div
                key={p.name}
                className="bg-black hover:bg-[#0f0f0f] transition-colors p-6 md:p-8 min-h-[140px] flex flex-col justify-between"
              >
                <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/40">
                  target
                </div>
                <div>
                  <div className="font-display font-black text-xl md:text-2xl tracking-tight">
                    {p.name}
                  </div>
                  <div className="mt-2 font-mono-tech text-[10px] uppercase tracking-widest text-[#FF3B30]">
                    {p.focus}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-6 font-mono-tech text-[10px] uppercase tracking-widest text-white/40">
            * Target organizations for upcoming briefings · No affiliation implied
          </div>
        </div>
      </section>

      <section className="relative py-24 md:py-28 bg-[#0a0a0a] border-y border-white/5" data-testid="partnership-path">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <SectionHeader
            kicker="/ engagement model"
            title={<>From NDA to prototype in<br />four phases.</>}
          />
          <ol className="mt-12 grid md:grid-cols-4 gap-4">
            {[
              { p: "01", t: "Briefing", d: "30-min technical walkthrough under mutual NDA." },
              { p: "02", t: "Data package", d: "Capability deck, performance envelopes, technical Q&A." },
              { p: "03", t: "Workshop", d: "Joint session mapping your platform to LogDrive configuration." },
              { p: "04", t: "Prototype", d: "Joint development / prototype program — scoped, milestoned, priced." },
            ].map((s) => (
              <li key={s.p} className="border border-white/10 p-6 bg-black">
                <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/50">
                  {s.p}
                </div>
                <div className="mt-2 font-display font-bold text-2xl">{s.t}</div>
                <p className="mt-3 text-white/70 leading-relaxed">{s.d}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="relative py-20 md:py-24" data-testid="investors">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/50">
              / investors
            </div>
            <h2 className="mt-4 font-display font-black text-3xl md:text-5xl tracking-tighter leading-[0.95]">
              Capital aligned with deep-tech timelines.
            </h2>
          </div>
          <div className="md:col-span-7 text-white/70 leading-relaxed">
            We work with investors who understand hardware cycles. Current capital is
            directed toward prototype runs, partner evaluation kits, and limited
            engineering-team expansion. For inquiries about the current round, contact
            us via the partnership form — a data room is available under NDA.
          </div>
        </div>
      </section>
    </main>
  );
}
